<template>
    <v-main class="justify-center" style="height: 100%; width: 100%; position: absolute;">
        <CardNav />
        <v-container>
            <v-row>
                <v-card elevation="12" style="height: calc(100svh - 13.4svh - 2svw - 2svw - 2svw - 2svw - 22.66svh); width: calc(100svw - 2svw - 2svw); margin-top: 2svw; margin-bottom: 2svw; margin-left: 2svw; margin-right: 2svw; border-radius: 9px; display: flex; flex-flow: column">
                    <img src="./../assets/images/arrow1.svg" class="transition-arrow1"
                        style="position: absolute; top: 24svh; left: 28.2svw; border: none; border-radius: unset" />
                    <img src="./../assets/images/arrow2.svg" class="transition-arrow2"
                        style="position: absolute; top: 24svh; left: 35svw; border: none; border-radius: unset" />
                    <img src="./../assets/images/arrow3.svg" class="transition-arrow3"
                        style="position: absolute; top: 24svh; left: 47svw; border: none; border-radius: unset" />
                </v-card>
                <v-card elevation="12"
                    style="height: calc(100svh - 13.4svh - 2svw - 2svw - 2svw - 2svw - calc(100svh - 13.4svh - 2svw - 2svw - 2svw - 2svw - 22.66svh)); width: calc(100svw - 2svw - 2svw); margin-left: 2svw; margin-right: 2svw; border-radius: 9px; display: flex; align-items: center; flex-direction: column; justify-content: center; gap: 1em;">
                    <div class="wrapper">
			<div class="progress-bar">
				<span class="progress-bar-fill" :style="styleProgress"></span>
			</div>
		</div>
                    <p
                        style="font-family: Lato; font-style: normal; color: #666563; font-size: 16px; font-weight: 300; letter-spacing: 0.095em;">
                        {{step}}. </p>
                </v-card>
            </v-row>
        </v-container>
    </v-main>
</template>

<script>
import axios from "axios";
import CardNav from './CardNav.vue';
import { nextScreen, nextScreenWithParams } from '../router/utils.js';
import { preference } from "vue-preferences";

const api = require('../../config/conf.env')

export default {
    name: 'SendingPhoto',
    components: {
        CardNav
    },
    data() {
        return {
            currentProgress: 0,
            step: "Enviando imagen...",
        }
    },
    computed: {
        styleProgress() {
            return {
                width: this.currentProgress + '%'
            }
        }
    },
    methods: {
        async click(token, filename, fileBase64) {
            var img = "";
            const onUploadProgress = (progressEvent) => {
                const percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
                this.currentProgress = percentCompleted;
            };
            await axios.post(api.partialUrl + api.process, {
                filename: filename,
                data_b64: fileBase64
            }, {
                headers: { Authorization: `${token}` },
                onUploadProgress
            }).then((res) => {
                img = res.data.image_id;
                this.step = "Procesando imagen...";
                this.currentProgress = 25;
                axios.get(api.partialUrl + api.group, {
                    headers: { Authorization: `${token}` }
                }).then((res) => {
                    this.currentProgress = 50;
                    if (res.data.group_id === 1) {
                        const requestInterval = setInterval(() => {
                            axios.get(api.partialUrl + api.process + "/" + img, {
                                headers: { Authorization: `${token}` }
                            }).then((res) => {
                                this.currentProgress = 75;
                                if (res.data.status !== "pending") {
                                    this.currentProgress = 100;
                                    clearInterval(requestInterval);
                                    if (res.data.status !== "error") {
                                        preference('status', { defaultValue: '' }).set(res.data.status); // if pending repeat
                                        preference('showResult', { defaultValue: '' }).set(res.data.show_result);
                                        preference('dialogClass', { defaultValue: '' }).set(res.data.diag_class);
                                        nextScreen(this.$router, '/photosent');
                                    } else {
                                        nextScreen(this.$router, '/imageerror');
                                    }
                                }
                            }).catch((error) => {
                                console.log(error);
                                nextScreen(this.$router, '/imageerror');
                            });
                        }, 1000);
                    } else {
                        nextScreenWithParams(this.$router, 'ProcessCompleted', true);
                    }
                }).catch((error) => {
                    console.log(error);
                    nextScreen(this.$router, '/errorphoto');
                });
            }).catch((error) => {
                console.log(error);
                // TODO: on a network error (e.g. we don't have internet connection), the error page won't load correctly
                if (error.response && error.response.status) {
                  if (error.response.status >= 400 && error.response.status < 500) {
                    nextScreen(this.$router, '/incompatibleerror');
                  } else if (error.response.status >= 500) {
                    nextScreen(this.$router, '/imageerror');
                  }
                } else {
                  nextScreen(this.$router, '/errorphoto');
                }
            });
        }
    },
    async mounted() {
        const token = preference('apiToken', { defaultValue: '' });
        const filenamePref = preference('filename', { defaultValue: '' });
        const fileBase64UrlPref = preference('fileBase64Url', { defaultValue: '' });
        // Get the Object URL from the preferences and read it as a blob
        const fileBase64Url = fileBase64UrlPref.get();
        const blob = await fetch(fileBase64Url).then(r => r.blob());

        const reader = new FileReader();
        reader.onloadend = () => {
          this.click(token.get(), filenamePref.get(), reader.result);
        };
        // Read the blob as a Data URL (this converts it to Base 64)
        reader.readAsDataURL(blob);
    }
}
</script>

<style>
.transition-arrow1 {
    animation: arrow1 0.9s linear;
    animation-iteration-count: infinite;
    opacity: 0;
}

.transition-arrow2 {
    animation: arrow2 0.9s linear;
    animation-iteration-count: infinite;
    opacity: 0;
}

.transition-arrow3 {
    animation: arrow3 0.9s linear;
    animation-iteration-count: infinite;
    opacity: 0;
}

@keyframes arrow1 {
    0% {
        opacity: 0;
    }

    30% {
        opacity: 1;
    }
}

@keyframes arrow2 {
    30% {
        opacity: 0;
    }

    60% {
        opacity: 1;
    }
}

@keyframes arrow3 {
    60% {
        opacity: 0;
    }

    90% {
        opacity: 1;
    }
}

.wrapper {
    width: 80%;
}

.progress-bar {
    width: 100%;
    background-color: #e0e0e0;
    padding: 3px;
    border-radius: 3px;
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, .2);
}

.progress-bar-fill {
    display: block;
    height: 0.6em;
    background-color: #059BCA;
    border-radius: 3px;
    
    transition: width 500ms ease-in-out;
}

</style>



// WEBPACK FOOTER //
// src/components/SendingPhoto.vue